import { ReactNode } from 'react';

import { SettingsContent } from '@/components/templates/SettingsContent/SettingsContent';
import { useDirtyFormBlocker } from '@/hooks/useDirtyFormBlocker';
import { RegisterSaveContext, useSectionSavers } from '@/hooks/useSectionSavers';

export const SettingsPage = ({ children }: { children: ReactNode }) => {
  const { registerSave, saveAllDirty } = useSectionSavers();

  useDirtyFormBlocker(saveAllDirty);

  return (
    <RegisterSaveContext.Provider value={registerSave}>
      <SettingsContent className="flex flex-col gap-12 pb-24">{children}</SettingsContent>
    </RegisterSaveContext.Provider>
  );
};
